<template src='./inputEstablishment.pug' lang='pug'></template>

<script>
import moment from 'moment'
import vSelect from 'vue-select'
import MultiSelectModal from '../../modals/multiSelectModal/MultiSelectModal'
import BetterInputTag from '../betterInputTag/BetterInputTag'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import LoadingPlaceholder from '../../loading/LoadingPlaceholder'
import { compareStrings } from '../../../utils/stringUtils.js'
import looseDeepEqual from '../../../utils/looseDeepEqual'

export default {
  name: 'InputEstablishment',

  components: {
    vSelect,
    MultiSelectModal,
    BetterInputTag,
    ButtonPrimary,
    LoadingPlaceholder
  },

  props: {
    id: {
      type: String,
      required: true
    },
    urls: {
      type: Object,
      required: true
    },
    selectedItems: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      noop: null,
      DEFAULT_COLUMNS: ['nome', 'cnpj', 'grupo'],
      selectedAttributesHolder: [],
      templateHolder: {},
      currentInputState: false,
      shown: false,
      icon: 'fa fa-spinner fa-spin',
      canShowModal: false,
      attributesList: [],
      dynamicColumns: [],
      establishments: {
        titles: {
          main: this.$t('movimentosFinanceiros.titulos.modalEstabelecimentoTitulo'),
          sub: this.$t('movimentosFinanceiros.titulos.modalEstabelecimentoSubtitulo')
        },
        unselectedItems: [],
        selectedItems: this.selectedItems,
        columns: ['nome', 'cnpj', 'grupo'],
        values: [],
        options: {
          columnsClasses: {nome: 'col-md-6', cnpj: 'col-md-3', grupo: 'col-md-3'},
          perPage: 5,
          headings: {
            nome: this.$t('administracao.operadores.labels.nome'),
            cnpj: this.$t('estabelecimentos.labels.cnpj'),
            grupo: this.$t('estabelecimentos.labels.grupoDeEstabelecimentos')
          },
          filterable: ['nome', 'cnpj', 'grupo'],
          filterByColumn: true,
          perPageValues: [],
          texts: {
            count: this.$t('dataTable.labels.contagem'),
            noResults: this.$t('dataTable.labels.semResultados'),
            filterBy: '',
            filterPlaceholder: this.$t('dataTable.labels.filtrar')
          },
          sortable: ['nome', 'cnpj', 'grupo'],
          sortIcon: {
            is: ''
          },
          responseAdapter: function (data) {
            for (const key in this.templateHolder) {
              this.establishments.options.templates[key] = this.templateHolder[key]
            }

            this.establishments.values = data.elements

            this.updateColumns(this.selectedAttributesHolder)

            return {
              data: data.elements,
              count: data.totalElements
            }
          }.bind(this),
          requestFunction: function (pagination) {
            for (const key in this.establishments.options.templates) {
              if (this.establishments.options.templates[key].name === LoadingPlaceholder.name) {
                continue
              }
              this.templateHolder[key] = this.establishments.options.templates[key]
              this.establishments.options.templates[key] = LoadingPlaceholder
            }

            return this.$store.dispatch('getEstablishments', this.mountFilters(pagination))
          }.bind(this),
          pagination: { chunk: 5 },
          orderBy: {
            ascending: true,
            column: 'nome'
          },
          customSorting: {
            nome: (asc) => {
              return (a, b) => {
                if (asc) {
                  return compareStrings(a.nome, b.nome)
                }
                return compareStrings(b.nome, a.nome)
              }
            },
            cnpj: (asc) => {
              return (a, b) => {
                if (asc) {
                  return compareStrings(a.cnpj, b.cnpj)
                }
                return compareStrings(b.cnpj, a.cnpj)
              }
            },
            grupo: (asc) => {
              return (a, b) => {
                if (asc) {
                  return compareStrings(a.grupo.nome, b.grupo.nome)
                }
                return compareStrings(b.grupo.nome, a.grupo.nome)
              }
            }
          },
          templates: {
            nome: (h, row) => row.nome,
            cnpj: (h, row) => {
              return row.cnpj ? row.cnpj.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})/, '$1.$2.$3/$4-$5') : '-'
            },
            grupo: (h, row) => {
              return row.grupo.nome
            }
          }
        }
      },
      defaultTags: [
        {
          id: '-1',
          nome: this.$t('inputTag.labels.todos')
        }
      ],
      inputTagsProps: {
        id: 'id',
        name: 'nome'
      },
      possibleTagsSearchTexts: {
        noResult: 'estabelecimentos.labels.filtro.semResultado',
        empty: 'estabelecimentos.labels.filtro.listaVazia'
      }
    }
  },

  watch: {
    'establishments.selectedItems': {
      handler () {
        this.$emit('update:establishments', this.establishments.selectedItems)
      },
      deep: true
    },
    selectedItems: {
      handler (newVal, oldVal) {
        if (!looseDeepEqual(oldVal, newVal)) {
          this.establishments.selectedItems = [...newVal]
        }
      },
      deep: true
    }
  },

  methods: {
    closeModal () {
      if (!this.currentInputState) {
        this.focusOnModal()
        this.shown = false
      }
    },

    open () {
      this.shown = this.canShowModal
    },

    mountFilters (pagination) {
      const filters = {}
      const atributosValores = []
      for (const key in pagination.query) {
        if (!this.DEFAULT_COLUMNS.includes(key)) {
          atributosValores.push(
            {
              idAtributoCfg: key.replace(/-.+?$/, ''),
              valor: pagination.query[key]
            }
          )
        } else {
          filters[key] = pagination.query[key]
        }
      }
      return {
        atributosValores,
        filters,
        ...pagination,
        url: this.urls.establishments
      }
    },

    updateColumns (selectedAttributes) {
      this.selectedAttributesHolder = selectedAttributes
      this.dynamicColumns = this.attributesList
        .filter(att => {
          return selectedAttributes.some(item => item.id === att.id)
        }).map(att => {
          return {
            column: att.id,
            heading: att.descricaoAtributo || att.nomeAtributo,
            template: ((id) => (h, row) => row[id] || '-')(att.id)
          }
        })
      this.establishments.values.map(value => {
        for (const attId of selectedAttributes) {
          value[attId] = '-'
        }
        for (const att of value.atributosValores) {
          const id = att.idAtributoCfg + '-' + att.nomeAtributo
          if (att.atributo.tipo === 'DATE') {
            value[id] = att.valor ? moment(att.valor).format('L') : '-'
          } else {
            value[id] = att.valor || '-'
          }
        }
        return value
      })
    },

    changeClickedInputState (state) {
      this.currentInputState = state
      if (!state) {
        this.focusOnModal()
      }
    },

    /**
     * @Hack
     * Objetivo desse hack é que algumas dependências do componente, nesse caso:
     * - vue-select para a seleção dos atributos;
     * - vue-tables-2 para listagem dos dados
     * Essas dependências fazem utilização dos evento de pressionamento de teclas, em particular do "ESC".
     * Como o componente de modal do Banking também utiliza o evento do "ESC" e o modal é destruído quando apertado a tecla,
     * os componentes dependentes que também utilizam do "ESC" quando o usuário está focado no input do respectivo.
     * Como o modal é destruído antes que o componente possa destruir (ou fazer qualquer coisa que precise) o seu input,
     * o mesmo lança um erro acusando que o input não existe (pois o modal foi destruído do ciclo de vida do Vue).
     * Esse hack faz com que o usuário "foque" no modal e não no input antes de destruir o modal.
     */
    focusOnModal () {
      this.$el.getElementsByClassName('modal-mask')[0].focus()
    },

    async getEstablishmentsFromServerDefault (queryValue, toIgnore) {
      this.$store.dispatch('cancelEstablishmentsSearchRequests')
      const filters = this.mountFilters({
        ascending: 1,
        orderBy: 'nome',
        page: 1,
        limit: 5,
        query: {
          nome: queryValue
        }
      })
      filters.toIgnore = toIgnore
      const response = await this.$store.dispatch('getEstablishments', filters)
      return response.elements
    }
  },

  created () {
    this.$store.dispatch('loadingData')
    this.$store.dispatch('loadEstablishmentAtt', this.urls.attributes)
      .then(response => {
        this.attributesList = response.map(att => {
          att.id = att.atributoCfg.id + '-' + att.nomeAtributo
          att.nomeDefinido = att.descricaoAtributo || att.nomeAtributo
          return att
        })
        this.icon = 'fa fa-search'
        this.$store.dispatch('dataLoaded')

        const dynamicAttsIds = this.attributesList.map(att => att.id)
        this.establishments.options.filterable.push(...dynamicAttsIds)
        this.canShowModal = true
      })
  }
}
</script>



// WEBPACK FOOTER //
// InputEstablishment.vue?aaa41950